import { AfterViewChecked, Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { AaRestatementService } from "../service/aa-restatement.service";
import { Restatement } from "../../../domains/Restatement"
import { DatePicker } from 'primeng/datepicker';
import { formatDate } from '@angular/common';
import Cleave from 'cleave.js';
import { GemsService } from 'client/app/shared';
import { concatMap } from 'rxjs/operators';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['../../../shared/styles/aa.less'],
  standalone: false
})
export class SelectComponent implements OnInit, AfterViewChecked {

  @Output() totalSubgroups = new EventEmitter<number>();
  @Output() selectedAA = new EventEmitter<Restatement[]>();
  @Output() selectedAD = new EventEmitter<string[]>();
  @ViewChild('effectiveDatecalendar', { static: false })
  effectiveDatecalendar: DatePicker;
  effectiveDatecalendarCleave: any = null;

  masterSubgroupList: Restatement[] = [];
  availableSubgroupsList: Restatement[];

  defaultSubgroupsList: Restatement[];
  // ["02013001 KOTZEBUE ELEC ASSN INC | 401K_PLANA_2017 002",
  //  "02013001 KOTZEBUE ELEC ASSN INC | RS_COMBINED_2017 001",
  //   "02013002 KOTZEBUE ELEC ASSN INC | RS_COMBINED_2017 001",
  //   "02013003 KOTZEBUE ELEC ASSN INC | RS_COMBINED_2017 001"];
  selectedSubgroupsList: string[] = [];
  selectedPlanType: string;
  filteredAvailableSubgroupsList: string[] = [];
  showConfirmMsgSuccess: boolean = false;
  subgroupFilterStarted: boolean = false;
  effectiveDateFilterStarted: boolean = false;
  uploadComplete: boolean = false;
  availableSubgroupText: string;
  disablePlanTypeAndAvailableSG: boolean = true;
  isRestatementFlag: boolean = false;
  coopSubgroup: string;
  planType: any = 'All Plan Types';
  hideEffectiveDateForRestatement: boolean = true;
  effectiveDateFormatted: string;
  planTypeFilterStarted: boolean = false;
  adoptionAgreementType: any;

  constructor(
    private aaRestatementService: AaRestatementService,
    private gemsService: GemsService
  ) { }

  ngOnInit(): void {
    this.adoptionAgreementType = 'Select'

    this.gemsService.getUser().pipe(
      concatMap(user => this.aaRestatementService.loadRestatements(user.person_id))
    ).subscribe(
      (data: any) => {
        this.defaultSubgroupsList = data;
        for (let i = 0; i < this.defaultSubgroupsList.length; i++) {
          this.masterSubgroupList.push(this.defaultSubgroupsList[i]);
        }
      });
  }

  outPutSelections() {
    this.availableSubgroupsList = []
    for (let i = 0; i < this.masterSubgroupList.length; i++) {
      this.availableSubgroupsList.push(this.masterSubgroupList[i]);
    }


    for (let x = 0; x < this.selectedSubgroupsList.length; x++) {
      for (let i = 0; i < this.availableSubgroupsList.length; i++) {
        if (this.availableSubgroupsList[i].PlanDocument == this.selectedSubgroupsList[x]) {
          this.availableSubgroupsList.splice(i, 1);
        }
      }
    }
  }

  outPutRemovals() {
    this.availableSubgroupsList = []
    for (let i = 0; i < this.masterSubgroupList.length; i++) {
      this.availableSubgroupsList.push(this.masterSubgroupList[i]);
    }

    for (let x = 0; x < this.selectedSubgroupsList.length; x++) {
      for (let i = 0; i < this.availableSubgroupsList.length; i++) {
        if (this.availableSubgroupsList[i].PlanDocument == this.selectedSubgroupsList[x]) {
          this.availableSubgroupsList.splice(i, 1);
        }
      }
    }
  }

  ngAfterViewChecked() {

    if (this.effectiveDatecalendar != undefined && this.effectiveDatecalendarCleave == null) {
      this.effectiveDatecalendarCleave = new Cleave(this.effectiveDatecalendar.inputfieldViewChild.nativeElement, {
        date: true,
        delimiter: '/',
        datePattern: ['m', 'd', 'Y']
      });
    }

  }
  navigateToStep2() {
    // let url = constants.uiRoutes.goToCompleteUrl.url;
    // window.location.href = url;
    var selectedRestatements: Restatement[] = [];
    for (var o = 0; o < this.selectedSubgroupsList.length; o++) {
      for (var i = 0; i < this.masterSubgroupList.length; i++) {
        if (this.masterSubgroupList[i].PlanDocument.includes(this.selectedSubgroupsList[o])) {

          let document: Restatement = {
            DocumentHeaderId: this.masterSubgroupList[i].DocumentHeaderId,
            AdoptionAgreementId: this.masterSubgroupList[i].AdoptionAgreementId,
            AddendumId: this.masterSubgroupList[i].AddendumId,
            PlanDocument: this.masterSubgroupList[i].PlanDocument,
            PlanType: this.masterSubgroupList[i].PlanType,
            SubgroupId: this.masterSubgroupList[i].SubgroupId,
            AddendumDocuments: this.masterSubgroupList[i].AddendumDocuments,
            isRestatement: this.masterSubgroupList[i].isRestatement
          }
          selectedRestatements.push(document);
        }
      }
    }
    this.selectedAA.emit(selectedRestatements);
  }

  loadAADocuments(AdoptionAgreementType: any) {


    //this.effectiveDatecalendarCleave = null;
    var availabledSubgroups = [];
    this.coopSubgroup = '';
    this.planType = 'All Plan Types';
    this.selectedPlanType = 'All Plan Types';
    var aaType = AdoptionAgreementType.target.value;
    this.availableSubgroupsList = [];
    this.filteredAvailableSubgroupsList = [];
    this.selectedSubgroupsList = [];
    this.planTypeFilterStarted = false;
    this.subgroupFilterStarted = false;

    if (aaType.trim() === 'Restatement' || aaType.trim() === 'NonRestatement') {
      this.disablePlanTypeAndAvailableSG = false;
      if (aaType.trim() === 'Restatement') {
        this.isRestatementFlag = true;
        this.hideEffectiveDateForRestatement = true;

        this.availableSubgroupsList = this.defaultSubgroupsList.reduce((accum, item) => {
          if (item.isRestatement) accum.push(item);
          return accum;
        }, []);

        this.filteredAvailableSubgroupsList = this.availableSubgroupsList.map(x => x.PlanDocument);
      }
      else if (aaType.trim() === 'NonRestatement') {
        this.hideEffectiveDateForRestatement = false;
        this.isRestatementFlag = false;
        // this.effectiveDatecalendarCleave == undefined;
        // NOTE: THIS WASNT DOING ANYTHING AND SHOULD BE CHECKED IF BUG IS HERE?

        if (this.effectiveDatecalendarCleave) { delete this.effectiveDatecalendarCleave; }

        this.availableSubgroupsList = this.defaultSubgroupsList.reduce((accum, item) => {
          if (!item.isRestatement) accum.push(item);
          return accum;
        }, []);

        this.filteredAvailableSubgroupsList = this.availableSubgroupsList.map(x => x.PlanDocument);
      }
      else {
        this.hideEffectiveDateForRestatement = false;
        this.isRestatementFlag = false;
      }
    }
    else {
      this.disablePlanTypeAndAvailableSG = true;
      this.hideEffectiveDateForRestatement = true;
    }
  }

  filterPlanType(searchText: any) {
    var text = searchText.target.value + '';
    var availabledSubgroups = [];
    this.filteredAvailableSubgroupsList = [];
    this.selectedSubgroupsList = [];
    var subgroupNumberPlantypeArray;
    var subgroupNumber;
    var planType;
    var coopName;
    this.selectedPlanType = text;
    this.coopSubgroup = '';
    this.subgroupFilterStarted = false;
    var isRestmtFromList;
    //set filter indicator
    if (text.trim() != 'All Plan Types') {
      this.planTypeFilterStarted = true;
    }
    else {
      this.planTypeFilterStarted = false;
    }
    if (this.effectiveDatecalendar && this.effectiveDatecalendar.value != '') {
      this.effectiveDatecalendar.inputFieldValue = '';
    }
    if (text.trim().includes('All Plan Types')) {
      for (let i = 0; i < this.defaultSubgroupsList.length; i++) {
        isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;
        if (this.adoptionAgreementType.trim() === 'Restatement') {
          if (isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (this.adoptionAgreementType.trim() === 'NonRestatement') {
          if (!isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
      };
      this.filteredAvailableSubgroupsList = [...availabledSubgroups];

    }
    else {
      for (var i = 0; i < this.defaultSubgroupsList.length; i++) {
        subgroupNumberPlantypeArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
        coopName = this.defaultSubgroupsList[i].PlanDocument.split("|").pop();
        subgroupNumber = subgroupNumberPlantypeArray[0] + coopName;
        planType = subgroupNumberPlantypeArray[2].trim().substring(0, 4);
        isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;
        //Added this condition to get the PlanType - 'RS'
        if (text == 'RS') {
          planType = subgroupNumberPlantypeArray[2].trim().substring(0, 2);
        }
        if (this.adoptionAgreementType.trim() === 'Restatement') {
          if (planType.includes(text) && isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (this.adoptionAgreementType.trim() === 'NonRestatement') {
          if (planType.includes(text) && !isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
      }

      this.filteredAvailableSubgroupsList = [...availabledSubgroups];
    }
  }

  pickListFilter(searchText: any) {
    var text = searchText.target.value.toUpperCase() + '';
    var availabledSubgroups = [];
    this.filteredAvailableSubgroupsList = [];

    this.selectedSubgroupsList = [];
    this.availableSubgroupText = text;
    var planType;
    var isRestmtFromList;
    if (this.effectiveDatecalendar && this.effectiveDatecalendar.value != '') {
      this.effectiveDatecalendar.inputFieldValue = '';
    }
    //set filter indicator
    if (text.trim() != '') {
      this.subgroupFilterStarted = true;
    }
    else {
      this.subgroupFilterStarted = false;
    }

    if (text.trim() == '' && this.selectedPlanType == "All Plan Types" && !this.uploadComplete) {

      for (let i = 0; i < this.defaultSubgroupsList.length; i++) {
        isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;
        if (this.adoptionAgreementType.trim() === 'Restatement') {
          if (isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (this.adoptionAgreementType.trim() === 'NonRestatement') {
          if (!isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
      };
      this.filteredAvailableSubgroupsList = [...availabledSubgroups];
    }

    else {
      for (var i = 0; i < this.defaultSubgroupsList.length; i++) {
        var subgroupNumberPlantypeArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
        //to get the last element after | (for coopName)
        var coopName = this.defaultSubgroupsList[i].PlanDocument.split("|").pop();
        var subgroupNumber = subgroupNumberPlantypeArray[0] + coopName;
        isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;

        planType = subgroupNumberPlantypeArray[2].trim().substring(0, 4);
        //Added this condition to get the PlanType - 'RS'
        if (this.selectedPlanType && this.selectedPlanType == 'RS') {
          planType = subgroupNumberPlantypeArray[2].trim().substring(0, 2); // to get Plan type use 2nd element
        }
        if (this.adoptionAgreementType.trim() === 'Restatement') {
          if (subgroupNumber.includes(text) && isRestmtFromList) {
            if (this.selectedPlanType && this.selectedPlanType != "All Plan Types") {
              if (this.selectedPlanType.includes(planType)) {
                availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
              }
            }
            else {
              availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
            }
          }
        }
        else if (this.adoptionAgreementType.trim() === 'NonRestatement') {
          if (subgroupNumber.includes(text) && !isRestmtFromList) {
            if (this.selectedPlanType && this.selectedPlanType != "All Plan Types") {
              if (this.selectedPlanType.includes(planType)) {
                availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
              }
            }
            else {
              availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
            }
          }
        }

      }
      this.filteredAvailableSubgroupsList = [...availabledSubgroups];

    }
  }


  pickListFilterByEffectiveDate(searchText: any) {
    // need to get the formatted date as MM/YY
    this.effectiveDateFormatted = formatDate(this.effectiveDatecalendar.value, 'MM/yy', 'en-US')
    var availabledSubgroups = [];
    this.filteredAvailableSubgroupsList = []
    this.selectedSubgroupsList = [];
    var planType;
    var availableSubgroupArray;
    var availableSGEffDate;
    var subgroupNumberPlantypeArray;
    var coopName;
    var subgroupNumber;
    var coopSearchtext = this.coopSubgroup.toUpperCase();
    var isRestmtFromList;
    var aaTypeSelected;
    if (this.adoptionAgreementType.trim() === 'Restatement') { aaTypeSelected = true; }
    else if (this.adoptionAgreementType.trim() === 'NonRestatement') { aaTypeSelected = false; }
    for (var i = 0; i < this.defaultSubgroupsList.length; i++) {

      availableSubgroupArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
      availableSGEffDate = availableSubgroupArray[1];
      subgroupNumberPlantypeArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
      //to get the last element after | (for coopName)
      coopName = this.defaultSubgroupsList[i].PlanDocument.split("|").pop();

      subgroupNumber = subgroupNumberPlantypeArray[0] + coopName;
      planType = subgroupNumberPlantypeArray[2].trim().substring(0, 4);
      isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;
      //Added this condition to get the PlanType - 'RS'
      if (this.selectedPlanType && this.selectedPlanType == 'RS') {
        planType = subgroupNumberPlantypeArray[2].trim().substring(0, 2); // to get Plan type use 2nd element
      }
      //following if-else conditions are based on whether there was any selections made on Plan Type and Coop Subgroup
      if (this.subgroupFilterStarted && this.planTypeFilterStarted) {
        if (availableSGEffDate.includes(this.effectiveDateFormatted) && this.selectedPlanType.includes(planType) && subgroupNumber.includes(coopSearchtext) && aaTypeSelected === isRestmtFromList) {
          availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
        }
      }
      else if (!this.subgroupFilterStarted && this.planTypeFilterStarted) {
        if (availableSGEffDate.includes(this.effectiveDateFormatted) && this.selectedPlanType.includes(planType) && aaTypeSelected === isRestmtFromList) {
          availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
        }
      }
      else if (this.subgroupFilterStarted && !this.planTypeFilterStarted) {
        if (availableSGEffDate.includes(this.effectiveDateFormatted) && subgroupNumber.includes(coopSearchtext) && aaTypeSelected === isRestmtFromList) {
          availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
        }
      }
      else {
        if (availableSGEffDate.includes(this.effectiveDateFormatted) && aaTypeSelected === isRestmtFromList) {
          availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
        }
      }
      this.filteredAvailableSubgroupsList = [...availabledSubgroups];
    }
    if ((this.effectiveDatecalendar.value == '' || this.effectiveDatecalendar.value == null) && !this.uploadComplete) {
      for (let i = 0; i < this.defaultSubgroupsList.length; i++) {
        this.filteredAvailableSubgroupsList = []
        availableSubgroupArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
        availableSGEffDate = availableSubgroupArray[1];
        subgroupNumberPlantypeArray = this.defaultSubgroupsList[i].PlanDocument.split('|')
        //to get the last element after | (for coopName)
        coopName = this.defaultSubgroupsList[i].PlanDocument.split("|").pop();
        subgroupNumber = subgroupNumberPlantypeArray[0] + coopName;
        planType = subgroupNumberPlantypeArray[2].trim().substring(0, 4);
        isRestmtFromList = this.defaultSubgroupsList[i].isRestatement;

        if (this.adoptionAgreementType.trim() === 'Restatement') { aaTypeSelected = true; }
        else if (this.adoptionAgreementType.trim() === 'NonRestatement') { aaTypeSelected = false; }

        if (this.selectedPlanType && this.selectedPlanType == 'RS') {
          planType = subgroupNumberPlantypeArray[2].trim().substring(0, 2); // to get Plan type use 2nd element
        }
        if (this.subgroupFilterStarted && this.planTypeFilterStarted) {
          if (subgroupNumber.includes(coopSearchtext) && this.selectedPlanType.includes(planType) && aaTypeSelected === isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (!this.subgroupFilterStarted && this.planTypeFilterStarted) {
          if (this.selectedPlanType.includes(planType) && aaTypeSelected === isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (this.subgroupFilterStarted && !this.planTypeFilterStarted) {
          if (subgroupNumber.includes(coopSearchtext) && aaTypeSelected === isRestmtFromList) {
            availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
          }
        }
        else if (!this.subgroupFilterStarted && !this.planTypeFilterStarted && aaTypeSelected === isRestmtFromList) {
          availabledSubgroups.push(this.defaultSubgroupsList[i].PlanDocument);
        }
        this.filteredAvailableSubgroupsList = [...availabledSubgroups];
      }
    }
  }

  uploadFile(files: FileList) {
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        var linesOfData = csv.split("\n");
        for (let i = 0; i < linesOfData.length; i++) {
          if (linesOfData[i]) {
            var lineSplit = linesOfData[i].split(",");
            //source filteredAvailableSubgroupsList
            //target selectedSubgroupsList
            for (let a = 0; a < this.filteredAvailableSubgroupsList.length; a++) {
              var subgroupNumberPlantypeArray = this.filteredAvailableSubgroupsList[a].split('|')
              var subgroupNumber = subgroupNumberPlantypeArray[0].substring(0, 8);
              var planType = subgroupNumberPlantypeArray[2].trim().substring(0, 4);
              var planTypeArray = subgroupNumberPlantypeArray[2].trim().split(' ')
              var planId = planTypeArray[1].trim();
              if (planType.includes("RS")) {
                planType = subgroupNumberPlantypeArray[2].trim().substring(0, 2);
              }
              if (subgroupNumber.includes(lineSplit[0]) && planType.toString().trim() == lineSplit[1].toString().trim()) {
                // add to target list
                if (lineSplit[2].toString().trim() == planId.toString().trim()) {
                  this.selectedSubgroupsList.push(this.filteredAvailableSubgroupsList[a]);

                  // remove from source list
                  this.filteredAvailableSubgroupsList.splice(a, 1);
                  this.uploadComplete = true;
                }
                else {
                  this.uploadComplete = false;
                }
              }
            }
          }
        }
        for (let x = 0; x < this.selectedSubgroupsList.length; x++) {
          for (let i = 0; i < this.availableSubgroupsList.length; i++) {
            if (this.availableSubgroupsList[i].PlanDocument == this.selectedSubgroupsList[x]) {
              this.availableSubgroupsList.splice(i, 1);
            }
          }
        }
      }


    }
  }
}



